export default __webpack_public_path__ + "static/media/female-avatar.8dc0e0dc.png";